export enum CubeSchemaName {
  WorkingDaysAnalyticsActivity = 'WorkingDaysAnalyticsActivity',
  WorkingDaysAnalyticsActivityV2 = 'WorkingDaysAnalyticsActivityV2',
}

export enum AppTimeSeriesCubeMetric {
  TimeInApp = 'TimeInApp', // Total duration
  Interactions = 'Interactions', // count
  AvgDuration = 'AvgDuration', // total duration / count
  CallTimeInApp = 'CallTimeInApp', // total call duration
  CallInteractions = 'CallInteractions', // call count
  CallAvgDuration = 'CallAvgDuration', // total call duration / call count
}

export enum AppGoalsCubeMetric {
  TimeInApp = 'TimeInApp',
  Interactions = 'Interactions',
  CallTimeInApp = 'CallTimeInApp',
  CallInteractions = 'CallInteractions',
  Score = 'Score',
}

export enum CubeTimeDimensionGranularity {
  Day = 'day',
  Week = 'week',
}

export enum Weekdays {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

export enum WeekdaysIdx {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}
